"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HS_CALLOUT = exports.HS_SANITIZE = exports.HS_TRANSFORM_ALERT = exports.HS_ANCHOR = exports.HS_VISUAL_BLOCKS = exports.HS_LISTS = exports.HS_PROTECT = exports.HS_NEWLINE = exports.HS_I18N = exports.HS_SETTING_PASSTHROUGH = exports.HS_TABLE_V2 = exports.HS_TABLE = exports.HS_EMOJI_INPAGE = exports.HS_EMOJI = exports.HS_EMAIL_EDITOR = exports.HS_PASTE = exports.HS_RSS_TOKEN = exports.HS_COLOR_INPAGE = exports.HS_COLOR = exports.HS_VIDEO_V2_INPAGE = exports.HS_VIDEO_V2 = exports.HS_VIDEO_INPAGE = exports.HS_VIDEO = exports.HS_MEDIA_INPAGE = exports.HS_MEDIA = exports.HS_USAGE = exports.HS_MORE = exports.HS_CODE_INPAGE = exports.HS_CODE = exports.HS_CTA_INPAGE = exports.HS_CTA = exports.HS_TRANSFORMER = exports.HS_FORMATTING = exports.HS_PERSONALIZE_INPAGE = exports.HS_PERSONALIZE = exports.HS_LINK_INPAGE = exports.HS_LINK = exports.HS_IMAGE_INPAGE = exports.HS_IMAGE = void 0;
var HS_IMAGE = 'hsimage_v3';
exports.HS_IMAGE = HS_IMAGE;
var HS_IMAGE_INPAGE = 'hsimage_v3_inpage';
exports.HS_IMAGE_INPAGE = HS_IMAGE_INPAGE;
var HS_LINK = 'hslink_v2_inapp';
exports.HS_LINK = HS_LINK;
var HS_LINK_INPAGE = 'hslink_v2_inpage';
exports.HS_LINK_INPAGE = HS_LINK_INPAGE;
var HS_PERSONALIZE = 'hspersonalize_v2';
exports.HS_PERSONALIZE = HS_PERSONALIZE;
var HS_PERSONALIZE_INPAGE = 'hspersonalize_v2_inpage';
exports.HS_PERSONALIZE_INPAGE = HS_PERSONALIZE_INPAGE;
var HS_FORMATTING = 'hsformatting';
exports.HS_FORMATTING = HS_FORMATTING;
var HS_TRANSFORMER = 'hstransformer';
exports.HS_TRANSFORMER = HS_TRANSFORMER;
var HS_CTA = 'hscta_v2';
exports.HS_CTA = HS_CTA;
var HS_CTA_INPAGE = 'hscta_v2_inpage';
exports.HS_CTA_INPAGE = HS_CTA_INPAGE;
var HS_CODE = 'hscode_v2';
exports.HS_CODE = HS_CODE;
var HS_CODE_INPAGE = 'hscode_v2_inpage';
exports.HS_CODE_INPAGE = HS_CODE_INPAGE;
var HS_MORE = 'hsmore_v2';
exports.HS_MORE = HS_MORE;
var HS_USAGE = 'hsusage';
exports.HS_USAGE = HS_USAGE;
var HS_MEDIA = 'hsmedia';
exports.HS_MEDIA = HS_MEDIA;
var HS_MEDIA_INPAGE = 'hsmedia_inpage';
exports.HS_MEDIA_INPAGE = HS_MEDIA_INPAGE;
var HS_VIDEO = 'hsvideo';
exports.HS_VIDEO = HS_VIDEO;
var HS_VIDEO_INPAGE = 'hsvideo_inpage';
exports.HS_VIDEO_INPAGE = HS_VIDEO_INPAGE;
var HS_VIDEO_V2 = 'hsvideo_v2';
exports.HS_VIDEO_V2 = HS_VIDEO_V2;
var HS_VIDEO_V2_INPAGE = 'hsvideo_v2_inpage';
exports.HS_VIDEO_V2_INPAGE = HS_VIDEO_V2_INPAGE;
var HS_COLOR = 'colorpicker_v2';
exports.HS_COLOR = HS_COLOR;
var HS_COLOR_INPAGE = 'colorpicker_v2_inpage';
exports.HS_COLOR_INPAGE = HS_COLOR_INPAGE;
var HS_RSS_TOKEN = 'hsrsstoken_v2';
exports.HS_RSS_TOKEN = HS_RSS_TOKEN;
var HS_PASTE = 'hspaste';
exports.HS_PASTE = HS_PASTE;
var HS_EMAIL_EDITOR = 'hsemaileditor';
exports.HS_EMAIL_EDITOR = HS_EMAIL_EDITOR;
var HS_EMOJI = 'hsemoji';
exports.HS_EMOJI = HS_EMOJI;
var HS_EMOJI_INPAGE = 'hsemoji_inpage';
exports.HS_EMOJI_INPAGE = HS_EMOJI_INPAGE;
var HS_TABLE = 'hstable';
exports.HS_TABLE = HS_TABLE;
var HS_TABLE_V2 = 'hstable2';
exports.HS_TABLE_V2 = HS_TABLE_V2;
var HS_SETTING_PASSTHROUGH = 'hssettingpassthrough';
exports.HS_SETTING_PASSTHROUGH = HS_SETTING_PASSTHROUGH;
var HS_I18N = 'hsi18n';
exports.HS_I18N = HS_I18N;
var HS_NEWLINE = 'hsnewline';
exports.HS_NEWLINE = HS_NEWLINE;
var HS_PROTECT = 'hsprotect';
exports.HS_PROTECT = HS_PROTECT;
var HS_LISTS = 'hslists';
exports.HS_LISTS = HS_LISTS;
var HS_VISUAL_BLOCKS = 'hsvisualblocks';
exports.HS_VISUAL_BLOCKS = HS_VISUAL_BLOCKS;
var HS_ANCHOR = 'hsanchor';
exports.HS_ANCHOR = HS_ANCHOR;
var HS_TRANSFORM_ALERT = 'hstransformalert';
exports.HS_TRANSFORM_ALERT = HS_TRANSFORM_ALERT;
var HS_SANITIZE = 'hssanitize';
exports.HS_SANITIZE = HS_SANITIZE;
var HS_CALLOUT = 'hscallout';
exports.HS_CALLOUT = HS_CALLOUT;